export default __webpack_public_path__ + "static/media/visual_hero.cfb0c7ee.svg";